import { useTheme } from '../../hooks/useTheme';

export interface ThemeToggleProps {
  className?: string | undefined;
  size?: 'sm' | 'md' | 'lg' | undefined;
}

export function ThemeToggle({ className = '', size = 'md' }: ThemeToggleProps) {
  const { toggleTheme, isDark } = useTheme();

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }[size];

  const buttonPadding = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-2.5',
  }[size];

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`relative inline-flex items-center justify-center rounded-xl border border-line bg-card text-ink shadow-card hover:bg-slate-500/10 focus:outline-blue transition-all cursor-pointer ${buttonPadding} ${className}`}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Sun Icon (shown when dark mode, to switch to light) */}
      <svg
        className={`${iconSizes} transition-transform duration-300 ${
          isDark ? 'rotate-0 scale-100 text-amber-400' : '-rotate-90 scale-0 text-amber-400 hidden'
        }`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>

      {/* Moon Icon (shown when light mode, to switch to dark) */}
      <svg
        className={`${iconSizes} transition-transform duration-300 ${
          !isDark ? 'rotate-0 scale-100 text-slate-700' : 'rotate-90 scale-0 text-slate-700 hidden'
        }`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>
  );
}
